import * as React from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import core, { App } from '@gin-betting/core';

import messages from './messages';
import SmartLink from '../SmartLink/SmartLink';
import './NoResults.scss';

const { getFiltersFromLocation } = core.utils;

interface OwnProps {
    type?: App.PageType;
    defaultSearchMessage?: string;
    inputMoreMessage?: string;
    defaultMessage?: string;
    noPageMessage?: string;
    listType?: App.PageType;
    linkHandler?: () => void;
    error?: any;
}

type Props = OwnProps & WrappedComponentProps;
class NoResults extends React.Component<Props> {
    getMessages = (): { message: string; linkMessage?: string } => {
        const { formatMessage } = this.props.intl;
        const {
            type,
            error,
            defaultSearchMessage = formatMessage(
                messages.noResultsMessageSearch
            ),
            defaultMessage = formatMessage(messages.noResultsMessageDefault),
            inputMoreMessage = formatMessage(messages.noResultsMessageMore),
            noPageMessage = formatMessage(messages.noResultsMessagePage),
        } = this.props;

        const { search, page } = getFiltersFromLocation();
        const showSecond = search && search.length < 2;

        if (type === 'list' && showSecond) return { message: inputMoreMessage };

        if (search) return { message: defaultSearchMessage };

        if (error) {
            return {
                message: defaultMessage,
                linkMessage: formatMessage(messages.noResultsMessageTryAgain),
            };
        }

        if (page && +page > 1) {
            return { message: noPageMessage, linkMessage: 'All Games' };
        }

        return { message: defaultMessage };
    };

    renderLinkedMessage = (linkMessage: string) => {
        const { linkHandler, listType } = this.props;

        const linkTo = listType || '/';

        return linkHandler ? (
            <div styleName="linked-message" onClick={linkHandler}>
                {linkMessage}
            </div>
        ) : (
            <SmartLink styleName="linked-message" to={linkTo}>
                {linkMessage}
            </SmartLink>
        );
    };

    render() {
        const { message, linkMessage } = this.getMessages();

        return (
            <div styleName="container" className="__app-NoResults-container">
                <div styleName="message" className="__app-NoResults-messages">
                    {message}
                </div>
                {linkMessage && this.renderLinkedMessage(linkMessage)}
            </div>
        );
    }
}

export default injectIntl(NoResults);
